import { TokenInfoWithPrice, useTrendingTokensQuery } from "@/api";
import { useDeferredValue } from "react";
import { TokenList } from "../token-list";
import { TabListBaseProps, filterRankSortTokens } from "./shared";

const EMPTY_LIST: TokenInfoWithPrice[] = [];

interface TrendingListProps extends TabListBaseProps {
  search: string;
  extraHeight?: number;
}

export function TrendingList({
  search,
  onSelectToken,
  scrollRef,
  extraHeight,
}: TrendingListProps) {
  const trendingTokensQuery = useTrendingTokensQuery();

  const rows = useDeferredValue(
    filterRankSortTokens(search, trendingTokensQuery.data ?? EMPTY_LIST),
  );

  return (
    <TokenList
      ref={scrollRef}
      rows={rows}
      id="trending-token-list"
      searchKey={search}
      isFetching={trendingTokensQuery.isFetching}
      hasNextPage={false}
      onSelectToken={onSelectToken}
      extraHeight={extraHeight}
    />
  );
}
